import React from "react";
import FilerobotImageEditor, {
  TABS,
  TOOLS,
} from "react-filerobot-image-editor";
import { FileUploader } from "react-drag-drop-files";
import { Row, Modal, Container, Button, Badge, Image, Col } from "react-bootstrap";
import UploadIcon from "../../assets/images/Folder.svg";

const fileTypes = ["JPG", "PNG", "JPEG", "PDF"];

const UploadDocument = ({
  item,
  index,
  handleChange,
  handleTypeStatus,
  sendUploadDocument,
  payload,
  isImgEditorShown,
  imageFile,
  closeImgEditor,
  setBase64,
  currentSelctedIDX,
}) => {
  return (
    <div className="document-file-uploader">
      <div className="document-upload" key={index}>
        {/* <div className="upload-icon">
          <span className="bx bx-upload"></span>
        </div> */}
        <div className="section-title-heading d-block">
          <h4 className="doc-name mb-0">{item.docName}{item && item.submission === "REQUIRED" && (<span className="text-danger"> *</span>)}</h4>
          <span className="divider"></span>
        </div>
        {/* <p>
          <span className="text-muted d-block">Upload a</span>
        </p> */}
        <div className="document-uploader-block">
          <div className="upload-icon-title">
            {/* <span className="bx bx-cloud-upload"></span> */}
            <Image src={UploadIcon} alt="Upload-icon" />
            <p className="upload-icon-title-text my-4">Upload or Drag your documents here</p>
            <p className="or-text position-relative">OR</p>
            <Button type="button" className="btn btn-light">Browse Files</Button>
          </div>
          <FileUploader
            handleChange={(file) => handleChange(file, index)}
            name="file"
            types={fileTypes}
          />
        </div>
        <p className="error-msg small" style={{ color: "red" }}>
          {item.fileError}
        </p>
        <div className="upload-file-extensions">
          <Badge variant="dark" className="badge-custom">PDF</Badge>
          <Badge variant="dark" className="badge-custom">JPG</Badge>
          <Badge variant="dark" className="badge-custom">PNG</Badge>
          <Badge variant="dark" className="badge-custom">JPEG</Badge>
        </div>
        {/* <button className="upload-doc">
          <i className="bx bx-upload"></i>
        </button> */}
        <section className="d-flex justify-content-between">
          <select
            className={`form-control d-inline-block ${item.givenDocNameErrorClass}`}
            onChange={(e) =>
              handleTypeStatus(
                e.target.value,
                currentSelctedIDX ? currentSelctedIDX : index
              )
            }
            key={index}
          >
            <option value="">Select document type</option>

            {item &&
              item.acceptableDoc.map((item, index) => {
                return <option key={index}>{item}</option>;
              })}
          </select>
          <Button
            variant="light"
            disabled={item.isDisable}
            // className="btn theme-btn-primary d-inline-block"
            onClick={() => sendUploadDocument(item._id, currentSelctedIDX)}
          >
            Send
          </Button>
        </section>
        <p className="error-msg small" style={{ color: "red" }}>
          {item.givenDocNameError}
        </p>
      </div>

      <Modal show={isImgEditorShown} className="comment-modal">
        <Modal.Body>
          <Container className="p-0">
            <Row>
              {isImgEditorShown && (
                <FilerobotImageEditor
                  source={imageFile}
                  closeAfterSave
                  onSave={(editedImageObject, designState) => {
                    if (!editedImageObject.imageBase64) return;
                    handleChange(editedImageObject, currentSelctedIDX);
                  }}
                  onClose={closeImgEditor}
                  onBeforeSave={() => false}
                  annotationsCommon={{
                    fill: "#ff0000",
                  }}
                  Text={{ text: "Filerobot..." }}
                  Crop={{
                    presetsItems: [
                      {
                        titleKey: "classicTv",
                        descriptionKey: "4:3",
                        ratio: 4 / 3,
                      },
                      {
                        titleKey: "cinemascope",
                        descriptionKey: "21:9",
                        ratio: 21 / 9,
                      },
                    ],
                    presetsFolders: [
                      {
                        titleKey: "socialMedia",
                        groups: [
                          {
                            titleKey: "facebook",
                            items: [
                              {
                                titleKey: "profile",
                                width: 180,
                                height: 180,
                                descriptionKey: "fbProfileSize",
                              },
                              {
                                titleKey: "coverPhoto",
                                width: 820,
                                height: 312,
                                descriptionKey: "fbCoverPhotoSize",
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  }}
                  tabsIds={[
                    TABS.ADJUST,
                    TABS.ANNOTATE,
                    TABS.WATERMARK,
                    TABS.FINETUNE,
                    TABS.FILTERS,
                    TABS.RESIZE,
                  ]}
                  defaultTabId={TABS.ANNOTATE}
                  defaultToolId={TOOLS.TEXT}
                />
              )}
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UploadDocument;
